var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartTruckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    iconsize: 20,
    className: "Icon-sc-1iwi4w1-0 yCMXi",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.896 12.548a2.508 2.508 0 012.506 2.506 2.508 2.508 0 01-2.506 2.505 2.508 2.508 0 01-2.505-2.505 2.508 2.508 0 012.505-2.506zm0 3.716a1.21 1.21 0 000-2.42 1.21 1.21 0 000 2.42zM4.708 12.548a2.508 2.508 0 012.506 2.506 2.508 2.508 0 01-2.506 2.505 2.508 2.508 0 01-2.505-2.505 2.508 2.508 0 012.505-2.506zm0 3.716a1.21 1.21 0 000-2.42c-.667 0-1.21.543-1.21 1.21 0 .667.543 1.21 1.21 1.21z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.538 5.66c.242 0 .465.135.576.35l1.814 3.52a.648.648 0 01.072.298v5.227c0 .357-.29.647-.648.647h-1.577v-1.296a.929.929 0 00.93-.928V9.985l-1.283-2.488a1 1 0 00-.889-.542h-4.33V5.66h5.335zM6.588 14.406h7.386v1.296H6.588v-1.296z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.648 2.44h11.555c.358 0 .648.29.648.648v11.966h-1.296V4.736a1 1 0 00-1-1H2.296a1 1 0 00-1 1v8.67a1 1 0 001 1h.555v1.296H.648A.648.648 0 010 15.054V3.088c0-.357.29-.648.648-.648z",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.203 9.2h7.149v1.297h-7.15V9.2z",
    fill: "#333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartTruckIcon);
export default __webpack_public_path__ + "static/media/CartTruckIcon.b1bfb309daa40270296be877dd510f84.svg";
export { ForwardRef as ReactComponent };